// Color constants for consistent theming
export const COLORS = {
  blue: '#0557D5',
  lightBlue: 'rgb(7, 104, 253)',
  white: '#FFFFFF',
  lightGray: '#F6F7FB',
  gray: '#D9D9D9',
  darkGray: '#333333',
  mediumGray: '#4D4D4D',
  textSecondary: '#595959',
};

// Font constants for consistent typography
export const FONTS = {
  weights: {
    normal: '400',
    medium: '500',
    semiBold: '600',
  },
  sizes: {
    small: '14px',
    medium: '16px',
    large: '18px',
  },
};

// Spacing constants for consistent layout
export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '35px',
};

// Export all constants as a single object for convenience
export default {
  COLORS,
  FONTS,
  SPACING,
};
